import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { BottomNav } from "@/components/BottomNav";
import { BetaBadge } from "@/components/BetaBadge";
import { AudioLoop } from "@/components/AudioLoop";
import { SettingsMenu } from "@/components/SettingsMenu";
import { AuthProvider } from "@/components/AuthProvider";
import IntroSplash from "@/pages/IntroSplash";
import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";
import DailySmash from "@/pages/DailySmash";
import Results from "@/pages/Results";
import CustomBuilder from "@/pages/CustomBuilder";
import PlayInvitation from "@/pages/PlayInvitation";
import CustomComparison from "@/pages/CustomComparison";
import CreateChallenge from "@/pages/CreateChallenge";
import PlayChallenge from "@/pages/PlayChallenge";
import MyStats from "@/pages/MyStats";
import Leaderboard from "@/pages/Leaderboard";
import DailyLeaderboard from "@/pages/DailyLeaderboard";
import DailyChallengeInvite from "@/pages/DailyChallengeInvite";
import WrappedPage from "@/pages/Wrapped";
import WeeklyWrapped from "@/pages/WeeklyWrapped";
import PowerSmash from "@/pages/PowerSmash";
import PowerLeaderboard from "@/pages/PowerLeaderboard";
import { NotificationBell } from "@/components/NotificationBell";
import AuthCallback from "@/pages/AuthCallback";
import About from "@/pages/About";

const Root = () => {
  let seen = false;
  try { seen = sessionStorage.getItem("cs.splash.seen") === "1"; } catch {}
  return seen ? <Navigate to="/home" replace /> : <Navigate to="/splash" replace />;
};

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback (session_id in URL fragment) BEFORE routes render.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Root />} />
      <Route path="/splash" element={<IntroSplash />} />
      <Route path="/home" element={<Landing />} />
      <Route path="/how" element={<HowItWorks />} />
      <Route path="/daily" element={<DailySmash />} />
      <Route path="/results" element={<Results />} />
      <Route path="/create" element={<CustomBuilder />} />
      <Route path="/play/:code" element={<PlayInvitation />} />
      <Route path="/compare/:code" element={<CustomComparison />} />
      <Route path="/challenge/new" element={<CreateChallenge />} />
      <Route path="/challenge/:id" element={<PlayChallenge />} />
      <Route path="/stats" element={<MyStats />} />
      <Route path="/leaderboards/prime" element={<Leaderboard />} />
      <Route path="/leaderboards/daily" element={<DailyLeaderboard />} />
      <Route path="/daily/vs/:code" element={<DailyChallengeInvite />} />
      <Route path="/wrapped" element={<WrappedPage />} />
      <Route path="/wrapped/weekly" element={<WeeklyWrapped />} />
      <Route path="/power" element={<PowerSmash />} />
      <Route path="/leaderboards/power" element={<PowerLeaderboard />} />
      <Route path="/about" element={<About />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <BottomNav />
          <BetaBadge />
          <NotificationBell />
          <SettingsMenu />
          <AudioLoop />
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "#16141D",
                color: "#FDFBF7",
                border: "1px solid rgba(255,16,122,0.4)",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
